import { createRouter, createWebHashHistory } from "vue-router";
const router = createRouter({
  history: createWebHashHistory(),
  routes: [
    {
      path: "/",
      name: "home",
      meta: {
        title: "Messages",
        forceRefresh: true,
      },
      component: () => import("../views/Home.vue"),
    },
    {
      path: "/order-message",
      name: "orderMessage",
      meta: {
        title: "Order Messages",
      },
      component: () => import("../views/OrderMessage.vue"),
    },
    {
      path: "/chatroom/:id",
      name: "chatroom",
      meta: {
        title: "chatroom",
        forceRefresh: true,
      },
      component: () => import("../views/Chatroom.vue"),
    },
    {
      path: "/service-notification",
      name: "serviceNotification",
      meta: {
        title: "Service Notification",
        forceRefresh: true,
      },
      component: () => import("../views/ServiceNotification.vue"),
    },
    {
      path: "/vip-notification",
      name: "vipNotification",
      meta: {
        title: "Vip Notification",
        forceRefresh: true,
      },
      component: () => import("../views/VipNotification.vue"),
    },
    {
      path: "/im-test",
      name: "imTest",
      meta: {
        title: "Im Test",
        forceRefresh: true,
      },
      component: () => import("../views/ImTest.vue"),
    },
    {
      path: "/ask-shop",
      name: "askShop",
      meta: {
        title: "AskShop",
      },
      component: () => import("../views/AskShop/index.vue"),
    },
  ],
});

export default router;
